import {
  Box,
  LinearProgress,
  linearProgressClasses,
  Typography,
} from "@mui/material";

export interface PMSetupStepsProps {
  totalSteps: number;
  completedSteps: number;
  title: string;
}

export function PMSetupSteps({
  title,
  completedSteps,
  totalSteps,
}: PMSetupStepsProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flex: 1,
        }}
      >
        <Typography fontWeight="500">{title}</Typography>
        <Typography fontWeight="500">
          ({`${completedSteps}/${totalSteps}`})
        </Typography>
      </Box>
      <LinearProgress
        variant="determinate"
        value={(completedSteps / totalSteps) * 100}
        sx={{
          borderRadius: 5,
          height: "6px",
          [`& .${linearProgressClasses.bar}`]: {
            backgroundColor: "#38BDF8",
          },
        }}
      />
    </Box>
  );
}
